import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import { fetchMouleSelectionBanner } from "../AirlineImages/FetchModule";

export const getCentralisedBannerDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  centralizedBanner: [
    {
      fieldName: "Order Sequence",
      fieldValue: "sequence",
      className: "col-span-6",
      type: "text",
      name: "sequence",
      formType: "number",
      label: "Order Sequence",
      placeholder: "Order Sequence",
      validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Mobile View Banner",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Mobile View Banner",
      placeholder: "Select Mobile View Banner",
      validation: { required: "Mobile View Banner is required" },
      imageDimension: {
        width: 20,
        height: 20,
      },
    },
    {
      fieldName: "Web View Banner",
      fieldValue: "web_image",
      className: "col-span-6",
      type: "image",
      name: "web_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Web View Banner",
      placeholder: "Select Web View Banner",
      validation: { required: "Web View Banner is required" },
    },
    {
      fieldName: "Tab View Banner",
      fieldValue: "tab_image",
      className: "col-span-6",
      type: "image",
      name: "tab_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Tab View Banner",
      placeholder: "Select Tab View Banner",
      // validation: { required: "Tab View Banner is required" },
    },
    {
      fieldName: "Video",
      fieldValue: "video",
      className: "col-span-6",
      type: "video",
      name: "video",
      formType: "file",
      usedFileType: "video/*",
      label: "Video",
      placeholder: "Select Video",
      // validation: { required: "Video is required" },
    },

    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Banner url",
      fieldValue: "redirect_url",
      className: "col-span-6",
      type: "text",
      name: "redirect_url",
      formType: "input",
      label: "Banner url",
      placeholder: "Enter Banner url",
      validation: {
        validate: (value: any): true | string => {
          if (!value || value === "" || typeof value !== "string") {
            return true;
          }
          const url = value.trim();
          const isInternal = url.startsWith("/");
          const isExternal = /^https?:\/\//i.test(url) || /^www\./i.test(url);
          return isInternal || isExternal ? true : "Please enter a valid URL (start with / or https://, http://, www.)";
        },
      },
    },
    // {
    //   fieldName: "Tags",
    //   fieldValue: "tag",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "tag",
    //   formType: "multiSelect",
    //   label: "Tags",
    //   placeholder: "Enter Tags",
    //   // validation: { required: "Tags is required" },
    //   loadOptions: fetchTagsSelection,
    // },
    // {
    //   fieldName: "Type",
    //   fieldValue: "type",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "type",
    //   formType: "multiSelect",
    //   label: "Type",
    //   placeholder: "Enter Type",
    //   // validation: { required: "Type is required" },
    //   loadOptions: fetchTypeSelection,
    // },
    {
      fieldName: "Published From",
      fieldValue: "start_date",
      className: "col-span-6",
      type: "dateTime",
      name: "start_date",
      formType: "dateTime",
      label: "Published From",
      placeholder: "Enter Published From",
      // validation: { required: "Published From is required" },
      validation: {
        validate: (value: string, formValues: any) => {
          const endDate = formValues.end_date;

          // If start date exists but end date is empty
          if (endDate && !value) {
            return "Please enter Start date";
          }

          // If both dates exist, validate order
          if (endDate && value) {
            const start = new Date(endDate).getTime();
            const end = new Date(value).getTime();

            if (start < end) {
              return "Published From should be earlier than Published Until";
            }
          }

          return true;
        },
      },
    },
    {
      fieldName: "Published Until",
      fieldValue: "end_date",
      className: "col-span-6",
      type: "dateTime",
      name: "end_date",
      formType: "dateTime",
      label: "Published Until",
      placeholder: "Enter Published Until",
      // validation: { required: "Published Until is required" },
      validation: {
        validate: (value: string, formValues: any) => {
          const startDate = formValues.start_date;

          // If start date exists but end date is empty
          if (startDate && !value) {
            return "Published Until is required";
          }

          // If both dates exist, validate order
          if (startDate && value) {
            const start = new Date(startDate).getTime();
            const end = new Date(value).getTime();

            if (end < start) {
              return "Published Until cannot be earlier than Published From";
            }
          }

          return true;
        },
      },
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionBanner,
    },
    // {
    //   fieldName: "MAGP",
    //   fieldValue: "magp_sync",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "magp_sync",
    //   formType: "checkbox",
    //   label: "MAGP",
    //   placeholder: "Enter MAGP Published",
    //   // validation: { required: "MAGP Publish is required" },
    // },
    // {
    //   fieldName: "ERAMAN Published",
    //   fieldValue: "eraman_sync",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "eraman_sync",
    //   formType: "checkbox",
    //   label: "ERAMAN Published",
    //   placeholder: "Enter ERAMAN Published",
    //   // validation: { required: "ERAMAN Publish is required" },
    // },
    // {
    //   fieldName: "ERAMAN KLIA 1",
    //   fieldValue: "eraman_klia1",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "eraman_klia1",
    //   formType: "checkbox",
    //   label: "ERAMAN KLIA 1",
    //   placeholder: "Enter ERAMAN Published",
    //   // validation: { required: "ERAMAN Publish is required" },
    // },
    // {
    //   fieldName: "ERAMAN KLIA 2",
    //   fieldValue: "eraman_klia2",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "eraman_klia2",
    //   formType: "checkbox",
    //   label: "ERAMAN KLIA 2",
    //   placeholder: "Enter ERAMAN Published",
    //   // validation: { required: "ERAMAN Publish is required" },
    // },
    // {
    //   fieldName: "ERAMAN Kuching",
    //   fieldValue: "eraman_kuching",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "eraman_kuching",
    //   formType: "checkbox",
    //   label: "ERAMAN Kuching",
    //   placeholder: "Enter ERAMAN Published",
    //   // validation: { required: "ERAMAN Publish is required" },
    // },
    // {
    //   fieldName: "ERAMAN Penang",
    //   fieldValue: "eraman_penang",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "eraman_penang",
    //   formType: "checkbox",
    //   label: "ERAMAN Penang",
    //   placeholder: "Enter ERAMAN Published",
    //   // validation: { required: "ERAMAN Publish is required" },
    // },
    // {
    //   fieldName: "ERAMAN Kota Kinabalu",
    //   fieldValue: "eraman_kota_kinabalu",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "eraman_kota_kinabalu",
    //   formType: "checkbox",
    //   label: "ERAMAN Kota Kinabalu",
    //   placeholder: "Enter ERAMAN Published",
    //   // validation: { required: "ERAMAN Publish is required" },
    // },
    // {
    //   fieldName: "ERAMAN Langkawi",
    //   fieldValue: "eraman_langkawi",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "eraman_langkawi",
    //   formType: "checkbox",
    //   label: "ERAMAN Langkawi",
    //   placeholder: "Enter ERAMAN Published",
    //   // validation: { required: "ERAMAN Publish is required" },
    // },
    // {
    //   fieldName: "CORPORATE",
    //   fieldValue: "corporate_sync",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "corporate_sync",
    //   formType: "checkbox",
    //   label: "CORPORATE",
    //   placeholder: "Enter CORPORATE Published",
    //   // validation: { required: "CORPORATE Publish is required" },
    // },
    // // {
    // //   fieldName: "PASSENGER Published",
    // //   fieldValue: "passenger_sync",
    // //   className: "col-span-12",
    // //   type: "checkbox",
    // //   name: "passenger_sync",
    // //   formType: "checkbox",
    // //   label: "PASSENGER Published",
    // //   placeholder: "Enter PASSENGER Published",
    // //   // validation: { required: "PASSENGER Publish is required" },
    // // },
    // {
    //   fieldName: "PASSENGER KLIA 1",
    //   fieldValue: "passenger_klia1",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "passenger_klia1",
    //   formType: "checkbox",
    //   label: "PASSENGER KLIA 1",
    //   placeholder: "Enter PASSENGER Published",
    //   // validation: { required: "PASSENGER Publish is required" },
    // },
    // {
    //   fieldName: "PASSENGER KLIA 2",
    //   fieldValue: "passenger_klia2",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "passenger_klia2",
    //   formType: "checkbox",
    //   label: "PASSENGER KLIA 2",
    //   placeholder: "Enter PASSENGER Published",
    //   // validation: { required: "PASSENGER Publish is required" },
    // },
    // {
    //   fieldName: "PASSENGER Kuching",
    //   fieldValue: "passenger_kuching",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "passenger_kuching",
    //   formType: "checkbox",
    //   label: "PASSENGER Kuching",
    //   placeholder: "Enter PASSENGER Published",
    //   // validation: { required: "PASSENGER Publish is required" },
    // },
    // {
    //   fieldName: "PASSENGER Penang",
    //   fieldValue: "passenger_penang",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "passenger_penang",
    //   formType: "checkbox",
    //   label: "PASSENGER Penang",
    //   placeholder: "Enter PASSENGER Published",
    //   // validation: { required: "PASSENGER Publish is required" },
    // },
    // {
    //   fieldName: "PASSENGER Kota Kinabalu",
    //   fieldValue: "passenger_kota_kinabalu",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "passenger_kota_kinabalu",
    //   formType: "checkbox",
    //   label: "PASSENGER Kota Kinabalu",
    //   placeholder: "Enter PASSENGER Published",
    //   // validation: { required: "PASSENGER Publish is required" },
    // },
    // {
    //   fieldName: "PASSENGER Langkawi",
    //   fieldValue: "passenger_langkawi",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "passenger_langkawi",
    //   formType: "checkbox",
    //   label: "PASSENGER Langkawi",
    //   placeholder: "Enter PASSENGER Published",
    //   // validation: { required: "PASSENGER Publish is required" },
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedBannerTags: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    // {
    //   fieldName: "Modules / Airports",
    //   fieldValue: "project_airport_id",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "project_airport_id",
    //   formType: "multiSelect",
    //   label: "Modules / Airports",
    //   placeholder: "Enter Modules / Airports",
    //   validation: { required: "Modules / Airports is required" },
    //   loadOptions: fetchMouleSelection,
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedBannerType: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      // validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_malay",
      className: "col-span-6",
      type: "text",
      name: "description_malay",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_mandarin",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Redirect Url",
      fieldValue: "redirect_url",
      className: "col-span-6",
      type: "text",
      name: "redirect_url",
      formType: "input",
      label: "Redirect Url",
      placeholder: "Enter Redirect Url",
      validation: { required: "Redirect Url is required" },
    },
    {
      fieldName: "View More Text",
      fieldValue: "button_text",
      className: "col-span-6",
      type: "text",
      name: "button_text",
      formType: "input",
      label: "View More Text",
      placeholder: "Enter View More Text",
      // validation: { required: "View More Text is required" },
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionBanner,
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
};
